<template>
  <div class="container-fluid">
    <!--
    <div class="row">
      <div class="col-md">賭飲料還沒完成哦！</div>
    </div>
    <div class="row">
      <b-button id="btn_Facebook" variant="primary" v-if="!fbUserInfo">
        <fb-signin-button
          :params="fbSignInParams"
          @success="onSignInSuccess"
          @error="onSignInError">
          <i class="material-icons">face</i> Login with Facebook
        </fb-signin-button>
      </b-button>
    </div>

    <div class="row" v-if="fbUserInfo">
      嗨！嗨！{{fbUserInfo.name}}
    </div>

    -->
  </div>
</template>

<script>

export default {
  name: 'DoInLiao',
  data () {
    return {
      fbSignInParams: {
        scope: 'email',
        return_scopes: true
      },
      fbUserInfo: undefined,
    }
  },
  methods:{
    onSignInSuccess (response) {
      FB.api('/me', dude => {
        console.log(`Good to see you, ${dude}.`)
        this.fbUserInfo = dude;
      })
    },
    onSignInError (error) {
      console.log('OH NOES', error)
    }
  },
  mounted: function(){
    
  },
  watch:{
    FB: function(){
      console.log("CHANGED")
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @font-face {
    font-family: 'Material Icons';
    font-style: normal;
    font-weight: 400;
    src: local('Material Icons'),
      local('MaterialIcons-Regular')
  }

  * {
    color: #FFF
  }

  .row{
    margin: 8px 0px;
  }

  .container-fluid {
    padding: 0px;
  }

  #btn_Facebook{
    
  }

</style>



// WEBPACK FOOTER //
// src/components/DoInLiao.vue